
import Injection = EECore.Injection;
import AdsService, { DEFAULT_ADSLIST_COMPONENT_NAME, DEFAULT_SLIDESHOW_COMPONENT_NAME } from "../../services/ads/adsService";
import AdsSlideshow from "./adsSlideshow";
import AdsList from "./adsList";

@Injection.injectableClass("AdsSwitcher")
export default class AdsSwitcher implements EECore.UI.IWebComponent {
  @Injection.injectableProperty("AdsSwitcher", "AdsService")
  private adsService: AdsService;

  @Injection.injectableProperty("AdsSwitcher", EECore.Registrations.WEBCOMPONENT_FACTORY)
  private webComponentFactory: EECore.UI.WebComponentFactory;

  @Injection.injectableProperty("AdsSwitcher", EECore.Registrations.DOCUMENT)
  private document: Document;

  constructor(adsService: AdsService, webComponentFactory: EECore.UI.WebComponentFactory, document: Document) {
    this.adsService = adsService;
    this.webComponentFactory = webComponentFactory;
    this.document = document;
  }

  load(container: Element, culture: string): EECore.Promise<Element, string> {
    const contentPath = container.getAttribute("ee-content-path");

    return new EECore.Promise<Element, string>((resolve, reject) => {
      const getAdsType = this.adsService.getTypeAds(contentPath) as EECore.Promise<string, string>;
      getAdsType.then((componentName) => {
        if (componentName === DEFAULT_SLIDESHOW_COMPONENT_NAME) {
          const adsSlideshowComponent = this.webComponentFactory.getWebComponent(AdsSlideshow);
          const adsSlideshowPromise = adsSlideshowComponent.load(container, culture) as EECore.Promise<Element, string>;
          adsSlideshowPromise.then((res: Element) => { resolve(res); });
        } else if (componentName === DEFAULT_ADSLIST_COMPONENT_NAME) {
          const adsListComponent = this.webComponentFactory.getWebComponent(AdsList);
          const adsListPromise = adsListComponent.load(container, culture) as EECore.Promise<Element, string>;
          adsListPromise.then((res: Element) => { resolve(res); });
        } else {
          resolve(this.document.createDocumentFragment() as any);
        }
      }).catch((error) => {
        reject(error);
      });
    });
  }
}